import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledGrid } from './Grid.styles.js';
const _excluded = ["children", "spacing"];
function Grid(_ref) {
  let {
      children,
      spacing
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const {
    container
  } = otherProps;
  const gridProps = container && spacing !== undefined ? _objectSpread2({
    spacing
  }, otherProps) : otherProps;
  return /*#__PURE__*/React__default.createElement(StyledGrid, gridProps, children);
}
Grid.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node,
  spacing: PropTypes.number
};
Grid.defaultProps = {
  children: null,
  spacing: 0
};
export { Grid as default };